const dropdowns = (state = {}, action) => {
  const localState = { ...state };
  switch (action.type) {
    case 'GET_DROPDOWNS_SUCCESS':
      if (action.data.data) {
        localState[action.data.data[0].key] = {
          editable: action.data.data[0].editable,
          options: action.data.data[0].options,
        };
      }
      return localState;
    case 'GET_REFERRALS_SUCCESS':
      if (action.data) {
        localState.referral = {
          editable: 1,
          options: action.data.data,
        };
      }
      return localState;
    case 'GET_REFERRAL_SUCCESS':
      if (action.data) {
        localState.referrallevel2 = {
          editable: 0,
          options: action.data.level2,
        };
        localState.referrallevel3 = {
          editable: 0,
          options: action.data.level3,
        };
      }
      return localState;
    default:
      return localState;
  }
};

export default dropdowns;



// WEBPACK FOOTER //
// ./src/Reducers/dropdowns.js